import { createBrowserRouter, Navigate } from 'react-router'
import { AuthGuard } from '@/components/auth/AuthGuard'
import { AppLayout } from '@/components/layout/AppLayout'
import { CallbackPage } from '@/pages/auth/CallbackPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { FamilyPage } from '@/pages/FamilyPage'
import { ReadingListPage } from '@/pages/ReadingListPage'
import { ActivitiesPage } from '@/pages/ActivitiesPage'
import { PortfolioPage } from '@/pages/PortfolioPage'

export const router = createBrowserRouter([
  // ─── OAuth callback ───────────────────────────────────────────────────────
  // Cognito redirects here after sign-in. Must match VITE_COGNITO_REDIRECT_SIGN_IN.
  // Amplify processes the ?code= param automatically; CallbackPage waits for the
  // Hub 'signedIn' event (via the store) then navigates to the original destination.
  {
    path: '/auth/callback',
    element: <CallbackPage />,
  },

  // ─── Protected app routes ─────────────────────────────────────────────────
  {
    element: <AuthGuard />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <Navigate to="/dashboard" replace /> },
          { path: 'dashboard', element: <DashboardPage /> },
          { path: 'family', element: <FamilyPage /> },
          { path: 'activities', element: <ActivitiesPage /> },
          { path: 'reading-list', element: <ReadingListPage /> },
          { path: 'portfolio', element: <PortfolioPage /> },
        ],
      },
    ],
  },

  // ─── Catch-all ────────────────────────────────────────────────────────────
  { path: '*', element: <Navigate to="/dashboard" replace /> },
])
